import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chart-legend-info',
  templateUrl: './chart-legend-info.component.html'
})
export class ChartLegendInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
